














import { Condition } from '@ajax/vue/components/templates/item-list/condition/contactlens/model/condition'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class BaseButtonVue extends Vue {
  @Prop({ required: true })
  readonly condition: Condition

  onClick(condition: Condition) {
    this.$emit('click', condition)
  }
}
